import {useBookingContext} from 'src/context/BookingContext';
import {InitialHeader} from '../initial/initialHeader';
import {BookingHeader} from '../Booking/BookingHeader/BookingHeader';

export function LocationHeader() {
    const {bookingState} = useBookingContext();

    const stepComponent = () => {
        if (bookingState.step === 'completed') {
            return null;
        }

        if (bookingState.steps.indexOf(bookingState.step) === 0) {
            return <InitialHeader />;
        }

        return <BookingHeader />;
    };

    return <>{stepComponent()}</>;
}
